import compose from "recompose/compose";

import gen from "./gen";
import people from "./people";
import theme from "./theme";
import resize from './resize';
import breakPoint from './break';
import genBoard from './board';

export default compose(gen, people, theme, resize, breakPoint, genBoard);